/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAWebNotification,
  PresenterAWebNotificationListResponse,
  PresenterCreateAWebNotificationRequest,
  PresenterError,
  PresenterIDResponse,
  PresenterResponse,
  PresenterUpdateAWebNotificationRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AWebNotification<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get notification list
   *
   * @tags AWeb-Notification
   * @name GetAdminNotifications
   * @summary Get the notification list
   * @request GET:/admin/notifications
   */
  getAdminNotifications = (
    query?: {
      "page[number]"?: number;
      "page[size]"?: number;
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebNotificationListResponse;
      },
      any
    >({
      path: `/admin/notifications`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create the notification
   *
   * @tags AWeb-Notification
   * @name PostAdminNotifications
   * @summary Create the notification
   * @request POST:/admin/notifications
   */
  postAdminNotifications = (
    body: PresenterCreateAWebNotificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebNotification;
      },
      any
    >({
      path: `/admin/notifications`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get detail Notification with id
   *
   * @tags AWeb-Notification
   * @name GetAdminNotificationsById
   * @summary Get detail the Notification
   * @request GET:/admin/notifications/{id}
   */
  getAdminNotificationsById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebNotification;
      },
      PresenterError
    >({
      path: `/admin/notifications/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update nottification
   *
   * @tags AWeb-Notification
   * @name PutAdminNotificationsById
   * @summary Update the nottification
   * @request PUT:/admin/notifications/{id}
   */
  putAdminNotificationsById = (
    id: number,
    body: PresenterUpdateAWebNotificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebNotification;
      },
      any
    >({
      path: `/admin/notifications/${id}`,
      method: "PUT",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Notification with id
   *
   * @tags AWeb-Notification
   * @name DeleteAdminNotificationsById
   * @summary Delete the Notification
   * @request DELETE:/admin/notifications/{id}
   */
  deleteAdminNotificationsById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      PresenterError
    >({
      path: `/admin/notifications/${id}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get notification list for aa
   *
   * @tags AWeb-Notification
   * @name GetNotifications
   * @summary Get the notification list for aa
   * @request GET:/notifications
   */
  getNotifications = (
    query?: {
      "page[number]"?: number;
      "page[size]"?: number;
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterAWebNotification[];
      },
      any
    >({
      path: `/notifications`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
